/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2025.8.17",
    versionName: "0.2.0-nightly.2025.8.17",
    versionChannel: "nightly",
    buildDate: "2025-08-17T00:09:42.787Z",
    commitHash: "fcb94c553baf458baed5bc8215784d749c6e25e4",
};
